module.exports = __webpack_public_path__ + "img/qiye.e083ec62.jpg";